import { useState, useRef } from "react";
import likapaiLogo from "./likapai-logo.png";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { IcCoffee } from "./Icons";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate  = useNavigate();
  const location  = useLocation();

  const [username,     setUsername]     = useState("");
  const [password,     setPassword]     = useState("");
  const [error,        setError]        = useState("");
  const [loading,      setLoading]      = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const usernameRef = useRef(null);
  const passwordRef = useRef(null);

  // Girişten önce gidilmek istenen sayfa
  const from = location.state?.from?.pathname || "/";

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Chrome auto-fill state'i güncellemeyebilir — DOM'dan fallback oku
    const actualUsername = username.trim() || usernameRef.current?.value?.trim() || "";
    const actualPassword = password       || passwordRef.current?.value          || "";
    if (!actualUsername || !actualPassword) return;

    setLoading(true);
    setError("");

    try {
      await login(actualUsername, actualPassword);
      navigate(from, { replace: true });
    } catch (err) {
      setError(err.message || "Giriş başarısız");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <img src={likapaiLogo} alt="LikapAI" style={{position:"fixed",bottom:20,right:20,width:128,height:128,objectFit:"contain",opacity:0.85}} />
      <form className="login-box" onSubmit={handleSubmit}>
        <div className="login-logo"><IcCoffee size={40} /></div>
        <div className="login-title">LikapAI Panel</div>
        <div className="login-sub">{localStorage.getItem("coas_cafe_name") || process.env.REACT_APP_CAFE_NAME || ""}</div>

        <div className="login-fields">
          <div className="login-field">
            <label htmlFor="username">Kullanıcı Adı</label>
            <input
              id="username"
              type="text"
              autoComplete="username"
              autoFocus
              ref={usernameRef}
              value={username}
              onChange={(e) => { setUsername(e.target.value); setError(""); }}
              disabled={loading}
              placeholder="admin"
            />
          </div>

          <div className="login-field">
            <label htmlFor="password">Şifre</label>
            <div className="login-pw-wrap">
              <input
                id="password"
                type={showPassword ? "text" : "password"}
                autoComplete="current-password"
                ref={passwordRef}
                value={password}
                onChange={(e) => { setPassword(e.target.value); setError(""); }}
                disabled={loading}
              />
              <button
                type="button"
                className="login-pw-toggle"
                onClick={() => setShowPassword(v => !v)}
                tabIndex={-1}
                aria-label={showPassword ? "Şifreyi gizle" : "Şifreyi göster"}
              >
                {showPassword ? (
                  /* Göz + çizgi (gizle) */
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="18" height="18">
                    <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20C7 20 2.73 16.11 1 12a10.94 10.94 0 0 1 2.06-3.94M9.9 4.24A9 9 0 0 1 12 4c5 0 9.27 3.89 11 8a10.94 10.94 0 0 1-1.28 2.5"/>
                    <line x1="1" y1="1" x2="23" y2="23"/>
                  </svg>
                ) : (
                  /* Göz (göster) */
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="18" height="18">
                    <path d="M1 12S5 4 12 4s11 8 11 8-4 8-11 8S1 12 1 12z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                )}
              </button>
            </div>
          </div>
        </div>

        {error && <div className="login-error">{error}</div>}

        <button
          type="submit"
          className="login-btn"
          disabled={loading}
        >
          {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
        </button>
      </form>
    </div>
  );
}
